import { render, staticRenderFns } from "./PcPage.vue?vue&type=template&id=0b430cac&scoped=true"
import script from "./PcPage.vue?vue&type=script&lang=js"
export * from "./PcPage.vue?vue&type=script&lang=js"
import style0 from "./PcPage.vue?vue&type=style&index=0&id=0b430cac&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b430cac",
  null
  
)

export default component.exports